// 支付页接口
import ajax from '@/utils/ajax';
import requestUrls from '@/assets/js/requestUrls';

const header = '/web';
// 支付成功页接口
export const reqPaySuccess = (orderNo) => ajax(`${header}/v1/pay/success/info?orderNo=${orderNo}`);
// 产品校验
export const reqCheckProduct = (data) => ajax(`${header}/v1/order/check/product`, data, 'POST');
// 计算价格
export const reqCalculation = (data) => ajax(`${header}/v1/order/price/calculation`, data, 'POST');
// 查询支付结果
export const reqPayResultOld = (orderNo, userId) => ajax(`${header}/v1/pay/pay-result?orderNo=${orderNo}&userId=${userId}`);
// 立即支付
export const reqImmediatepay = (data) => ajax(`${header}/v1/pay/immediate-payment`, data, 'POST');
// 收银台订单相关信息请求接口
export const reqCashierInfo = (orderNo) => ajax(`${header}/v1/pay/cashier-desk-info?orderNo=${orderNo}`);
// 提交订单
export const reqSubOrder = (data) => ajax(`${header}/v1/order/commit`, data, 'POST');
// 查询分期金额
export const reqHbPayabler = (payAmount) => ajax(`${header}/v1/pay/hb-payable?payAmount=${payAmount}`);
// 花呗信息初始化
export const reqOrderProductCheck = (requestBody) => (ajax(requestUrls.reqCheckOrderProductUrl, requestBody, 'POST'));
// 获取订单产品信息
export const reqOrderProductInfo = async (selectedProductSkus) => {
  try {
    const requestUrl = `${requestUrls.reqProductInfoUrl}?ids=${selectedProductSkus.map((productSku) => (productSku.productId)).join('&ids=')}`;
    return ajax(requestUrl);
  } catch (e) {
    return new Error(e);
  }
};
// 联报推荐
export const reqUnionRecommend = (requestBody) => (ajax(requestUrls.reqUnionRecommendUrl, requestBody, 'POST'));
// 获取订单促销信息
export const reqOrderPriceInfo = (requestBody) => (ajax(requestUrls.reqOrderPriceInfoUrl, requestBody, 'POST'));
// 提交订单
export const postOrderCommit = (requestBody) => (ajax(requestUrls.orderCommitUrl, requestBody, 'POST'));
// 订单产品校验
export const reqOrderValidation = (requestParams) => (ajax(requestUrls.reqOrderValidationUrl, requestParams));
// 支付信息初始化
export const reqPayInfo = (requestParams) => (ajax(requestUrls.reqCashierInfoUrl, requestParams));
// 花呗信息初始化
export const reqHuabeiInfo = (requestParams) => (ajax(requestUrls.reqHuabeiInfoUrl, requestParams));
// 立即支付
export const reqPayImmediate = (requestParams) => (ajax(requestUrls.reqPayImmediateUrl, requestParams, 'POST'));
// 获取支付成功页信息
export const reqPaySuccessInfo = (requestParams) => (ajax(requestUrls.reqPaySuccessInfoUrl, requestParams));
// 促销计价接口
export const reqPrice = (data) => ajax(`${header}/v1/price`, data, 'POST');
// 获取支付成功页信息
export const reqUserOrderCouponList = (requestParams) => (ajax(requestUrls.reqUserOrderCouponListUrl, requestParams, 'POST'));
// 查询支付状态
export const reqPayResult = (requestParams) => ajax(requestUrls.reqPayResultUrl, requestParams);
// 查询开课状态
export const reqCourseStartStatus = (requestParams) => ajax(requestUrls.reqCourseStartStatusUrl, requestParams);

// 退换课 收银台订单相关信息请求接口
export const reqReturnClassCashierInfo = (requestParams) => (ajax(requestUrls.reqReturnCashierInfoUrl, requestParams));
// 退换课 立即支付
export const reqReturnClassImmediatepay = (requestParams) => (ajax(requestUrls.reqReturnPayImmediateUrl, requestParams, 'POST'));
// 退换课 查询补款结果
export const reqReturnPayResult = (requestParams) => ajax(requestUrls.reqReturnPayResultUrl, requestParams);

// 发起拼团订单接口
export const postGroupCommit = (data) => ajax(`${header}/v1/group`, data, 'POST');
// 拼团立即支付接口
export const reqPostGroupPayPayment = (data) => ajax(`${header}/v1/group/pay/payment`, data, 'POST');
// 拼团订单收银台相关信息
export const reqGetGroupCashierInfo = (data) => ajax(`${header}/v1/group/pay/cashier-desk-info`, data, 'GET');
// 拼团获取计价接口
export const reqPostGroupPrice = (data) => ajax(`${header}/v1/group/price`, data, 'POST');
// 拼团订单支付查询
export const reqGetGroupPayResult = (data) => ajax(`${header}/v1/group/pay/pay-result`, data, 'GET');
// 参加拼团接口
export const reqPostGroupJoinCommit = (data, groupId) => ajax(`${header}/v1/group/${groupId}`, data, 'POST');

// 定金相关接口
// 定金单收银台订单相关信息
export const reqGetDepositDeskInfo = (depositOrderNo, type) => ajax(`${header}/v1/pay/deposit-cashier-desk-info?depositOrderNo=${depositOrderNo}&type=${type}`, '', 'GET');

// 查询定金单支付结果
export const reqGetDepositPayResult = (depositOrderNo) => ajax(`${header}/v1/pay/deposit-pay-result`, depositOrderNo, 'GET');

// 定金单支付校验相关信息
export const reqGetDepositPayVerify = (depositOrderNo) => ajax(`${header}/v1/pay/deposit-pay-verify`, depositOrderNo, 'GET');

// 定金单支付
export const reqPostDepositPayment = (data) => ajax(`${header}/v1/pay/deposit-payment`, data, 'POST');

// 加载定金单成功页
export const reqGetDepositInfo = (depositOrderNo) => ajax(`${header}/v1/pay/success/deposit-info`, depositOrderNo, 'GET');

// 白条分期
export const reqGetJdbtfq = (amount, orderNo) => ajax(`${header}/v1/pay/btfq-payable?orderNo=${orderNo}&amount=${amount}`, '', 'GET');

// 支付成功后弹出赠送优惠券列表
export const reqCouponGiftSuc = (orderNo) => ajax(`${header}/v1/pay/success/gift?orderNo=${orderNo}`);

// 获取根据订单号获取支付的标签
export const reqGetSubject = (orderNo) => ajax(`${header}/v1/question-bank/home/order/list?orderNo=${orderNo}`, '', 'GET');
// 获取真题实战相关产品信息
export const getVideoAnalysis = (data) => ajax(`${header}/v1/question-bank/user-subject/relation-list/skus`, data, 'POST');
